"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsLinks_en_us = void 0;
function componentsLinks_en_us() {
    return {
        "components.links.title": "Links",
        "components.links.unknowntype": "Unknown Type",
        "components.links.labels.customer": "Customer",
        "components.links.reversedlinks.nonefound": "No links found"
    };
}
exports.componentsLinks_en_us = componentsLinks_en_us;
